export function buildUrl(roleSlug, loadout) {
    const params = new URLSearchParams();

    loadout.forEach((entry) => {
        params.append(entry.kind === 'aura' ? 'aura' : 'item', entry.slug);
    });

    return `/guides/roles/${encodeURIComponent(roleSlug)}/hypothetical?${params.toString()}`;
}

function readError(response) {
    return response
        .json()
        .catch(() => ({}))
        .then((body) => {
            throw new Error(body.error || 'Those readings could not be worked out.');
        });
}

// Every keystroke on the picker would otherwise be a mock game on the server, and a slow
// earlier answer arriving after a fast later one would leave the table disagreeing with the
// chips that produced it. The sequence number is what rules the stale answer out; aborting is
// only the courtesy that stops the work.
export function createReadingsLoader(options) {
    const settings = options || {};
    const fetchImpl = settings.fetch || ((url, init) => window.fetch(url, init));
    const delay = typeof settings.delay === 'number' ? settings.delay : 150;

    let sequence = 0;
    let timer = null;
    let controller = null;

    function cancel() {
        if (timer !== null) {
            clearTimeout(timer);
            timer = null;
        }

        if (controller) {
            controller.abort();
            controller = null;
        }
    }

    function load(roleSlug, loadout, handlers) {
        cancel();
        sequence += 1;
        const mine = sequence;

        timer = setTimeout(() => {
            timer = null;
            controller = typeof AbortController === 'undefined' ? null : new AbortController();
            const init = controller ? { signal: controller.signal } : {};

            fetchImpl(buildUrl(roleSlug, loadout), init)
                .then((response) => (response.ok ? response.json() : readError(response)))
                .then((readings) => {
                    if (mine === sequence) handlers.onReadings(readings);
                })
                .catch((error) => {
                    if (mine === sequence && error.name !== 'AbortError') handlers.onError(error);
                });
        }, delay);
    }

    return { load, cancel };
}

export default createReadingsLoader;
